// extracted by mini-css-extract-plugin
export default {"recipient":"RecipientsSection_recipient__rf2bz","name":"RecipientsSection_name__WMHWc","statusTag":"RecipientsSection_statusTag__K+mWf"};